import { GrIcon, GrStack } from "@jnpmedi/grebob";
import { Link } from "react-router-dom";
import { AppLogo } from "@newComponents/common/logo/AppLogo";
import { getLocalStorageDocsVersion } from "@newHooks/common/useDocsVersion";
import { useLayoutContext } from "@newHooks/context/layout/layout.context";
import { useOrganizationContext } from "@newHooks/context/organization/organization.context";
import { baseHeight } from "@assets/theme/baseSize/baseHeight";
import Style from "./LeftSideBar.styled";
import { NaviList } from "../../../newComponents/header/navi/NaviList";
import { getNaviList } from "../navi";

interface LeftSideBarProps {
  isSignerTokenView?: boolean;
}

export function LeftSideBar({ isSignerTokenView = false }: LeftSideBarProps) {
  const { organizations } = useOrganizationContext();
  const { sidebarCollapsed, onSidebarPinToggle, isHiddenSideBar } = useLayoutContext();
  const naviList = getNaviList({ organizations });
  const version = getLocalStorageDocsVersion();

  return (
    <>
      {!isHiddenSideBar.value && (
        <Style.SideBarWrapper sidebarCollapsed={sidebarCollapsed}>
          <Style.SideBarSection>
            <Style.LogoWrapper>
              <Link to="/">
                <AppLogo />
              </Link>

              <Style.PinWrapper className="sidebar-pin" onClick={onSidebarPinToggle}>
                <GrIcon size={16} color="maven-blue-bright" type={sidebarCollapsed.value ? "arrow-bar-to-left" : "pin"} />
              </Style.PinWrapper>
            </Style.LogoWrapper>

            <GrStack
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              height={`calc(100vh - ${baseHeight.appHeaderHeight})`}
              padding="12px"
              style={{ boxSizing: "border-box" }}
            >
              <NaviList naviItems={!isSignerTokenView ? naviList : []} />

              <GrStack flexDirection="column" alignItems="center">
                <Style.VersionWrapper className="version-text">Version {version}</Style.VersionWrapper>
              </GrStack>
            </GrStack>
          </Style.SideBarSection>
        </Style.SideBarWrapper>
      )}
    </>
  );
}
